<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <br /><br /><br /><br />
          <div id="b24form"></div>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_IS_VIEW_ALL_EXPERTISE, SET_MAIN_MENU } from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "Idea",
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    const script = document.createElement("script");
    script.setAttribute("data-b24-form", "inline/90/p46t43");
    script.setAttribute("data-skip-moving", "true");
    script.innerHTML = `(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://portal.frprf.ru/upload/crm/form/loader_90_p46t43.js')`;
    document.getElementById("b24form").appendChild(script);

    this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name: "Мои проекты",
          route: "Projects"
        }
      ]);
    }
  },
  beforeDestroy() {
    const b24form = document.getElementById("b24form");
    if (b24form) {
      b24form.innerHTML = "";
    }
  }
};
</script>

<style scoped>
.wraper {
  min-height: calc(100vh - 60px);
  padding-bottom: 60px;
}

.content {
  padding: 0 15px;
}

.content_table {
  background-color: #fff;
  min-height: calc(100vh - 170px);
}

.mycontainer-fluid {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
